<template>
  <div>
    <Navigation />
    <div class="pa-5 flex space-between">
      <MaterialCategoryFilters />
      <ElButton @click="$refs.categoryDialog.add()" type="primary"
        >Adauga Categorie</ElButton
      >
    </div>
    <!-- table -->
    <ResourceTable
      :query="query"
      :filter="filter"
      :default-sort="{ prop: 'data.name' }"
    >
      <ElTableColumn type="index" width="50" />
      <ElTableColumn prop="data.name" label="Nume" sortable />
      <ElTableColumn label="Creare" sortable sort-by="data.createdAt.seconds">
        <TimeAgo
          slot-scope="{ row }"
          v-if="row.data.createdAt"
          :date="row.data.createdAt.toDate()"
        />
      </ElTableColumn>
      <ElTableColumn
        label="Actualizare"
        sortable
        sort-by="data.updatedAt.seconds"
      >
        <TimeAgo
          slot-scope="{ row }"
          v-if="row.data.updatedAt"
          :date="row.data.updatedAt.toDate()"
        />
      </ElTableColumn>
      <ElTableColumn align="right" width="200">
        <template slot-scope="{ row }">
          <ElButton @click="goToMaterials(row.id)" size="mini"
            >Materiale</ElButton
          >
          <ElButton @click="$refs.categoryDialog.edit(row.id)" size="mini"
            >Modifica</ElButton
          >
        </template>
      </ElTableColumn>
    </ResourceTable>
    <!-- dialogs -->
    <MaterialCategoryDialog ref="categoryDialog" />
  </div>
</template>

<script>
import FiltersMixin from "@/mixins/FiltersMixin";
import MaterialCategoryDialog from "@/components/materials/MaterialCategoryDialog";
import MaterialCategoryFilters from "@/components/materials/MaterialCategoryFilters";

export default {
  mixins: [FiltersMixin()],
  components: {
    MaterialCategoryDialog,
    MaterialCategoryFilters
  },
  computed: {
    query() {
      return this.$firestore().collection("materialCategories");
    }
  },
  methods: {
    filter(row) {
      const { filters } = this;
      if (filters.name) {
        if (row.data.name.match(new RegExp(filters.name, "i")) === null) {
          return false;
        }
      }
      return true;
    },
    goToMaterials(category) {
      this.$router.push({ path: "/materials", query: { category } });
    }
  }
};
</script>
